"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("../../../core");
exports.style = function (name, definitions) {
    var styleIdent = '$' + name;
    // local cache
    var style = document.head[styleIdent];
    ;
    // replace/update style
    if (!style) {
        // add
        style = document.createElement('style');
        document.head.appendChild(style);
        style.type = 'text/css';
        setStyle(style, definitions);
        // local cache
        document.head[styleIdent] = style;
    }
    else {
        setStyle(style, definitions);
    }
    return style;
};
var setStyle = function (style, definitions) {
    if (style.childNodes[0]) {
        style.removeChild(style.childNodes[0]);
    }
    style.appendChild(document.createTextNode(definitions));
};
core_1.st.style = exports.style;
//# sourceMappingURL=style.js.map